import G from "../../assets/icons/icon-metamask.svg.js";
import b from "../../assets/icons/icon-okx.svg.js";
import L from "../../assets/icons/icon-ronin.svg.js";
import d from "../../config/index.js";
import { ChainNetworkType as a, CHAIN_CONFIG_MAP as v, ChainEnvironment as E, ChainType as l, ChainAddressType as i } from "../../constants/chain.js";
import { WalletType as e, WAGMI_RECENT_CONNECTOR_ID as S, WalletExtensionRdns as Y, WalletProviderType as R } from "../../constants/web3.js";
import { useConfigContext as _ } from "../../contexts/config/ConfigContext.js";
import { getProvider as U } from "../../util/authenication/index.js";
import { isIosOrAndroid as V, isOkxApp as $ } from "../../util/browser/index.js";
import { walletRdnsToType as T } from "../../util/wallet/walletRdnsToType.js";
import { getAccount as B } from "@wagmi/core";
import * as p from "ramda";
import * as D from "ramda-adjunct";
import { useCallback as o } from "react";
import { useTranslation as F } from "react-i18next";
const re = () => {
  const {
    t: N
  } = F(), {
    config: C
  } = _(), {
    chainSwitcher: s
  } = C, w = (s == null ? void 0 : s.preferredNetwork) || a.Ronin, u = o(() => v[E.Mainnet], []), O = o((n) => {
    switch (n) {
      case l.Polygon:
      case l.PolygonTestnet:
        return d.URL.TRANSACTION.POLYGON;
      case l.Ronin:
      case l.RoninTestnet:
      default:
        return d.URL.TRANSACTION.RONIN;
    }
  }, []), y = o((n) => {
    var t;
    return (t = u().find((r) => r.chainAddressType === n)) == null ? void 0 : t.chainId;
  }, [u]), k = o((n) => {
    var r, c;
    const t = u();
    switch (n) {
      case e.Metamask:
        return (r = t.find((f) => f.chainAddressType === i.POLYGON)) == null ? void 0 : r.chainId;
      case e.Ronin:
      case e.RoninMobile:
      case e.Okx:
      case e.WalletConnect:
      default:
        return (c = t.find((f) => f.chainAddressType === i.RONIN)) == null ? void 0 : c.chainId;
    }
  }, [u]), m = o(() => {
    var c;
    const n = p.isNotNil(s) ? B(s.wagmiConfig) : null;
    if (n != null && n.connector)
      return T(n.connector.id);
    const t = typeof window < "u" ? (c = localStorage.getItem(S)) == null ? void 0 : c.replace(/['"]+/g, "") : void 0;
    if (t && Object.values(Y).includes(t))
      return T(t);
    const r = U();
    if (D.isNotNilOrEmpty(r))
      return r;
    switch (w) {
      case a.Polygon:
        return e.Metamask;
      case a.Ronin:
      default:
        return V() && !window.ronin && !$() ? e.RoninMobile : e.Ronin;
    }
  }, [s, w]), g = o((n) => {
    switch (n) {
      case e.Metamask:
        return N("common.network.polygon");
      case e.Okx:
      case e.Ronin:
      case e.RoninMobile:
      case e.WalletConnect:
      default:
        return N("common.network.ronin");
    }
  }, [N]), h = o((n) => {
    switch (n) {
      case e.Metamask:
        return G;
      case e.Okx:
        return b;
      case e.Ronin:
      case e.RoninMobile:
      case e.WalletConnect:
      default:
        return L;
    }
  }, []), I = o((n) => {
    switch (n) {
      case e.Metamask:
        return window.ethereum;
      case e.Okx:
        return window.okxwallet;
      case e.Ronin:
      case e.RoninMobile:
      case e.WalletConnect:
      default:
        return window.ronin;
    }
  }, []), A = o((n) => {
    switch (n) {
      case e.Metamask:
        return l.Polygon;
      case e.Okx:
      case e.Ronin:
      case e.RoninMobile:
      case e.WalletConnect:
      default:
        return l.Ronin;
    }
  }, []), M = o((n, t = {
    walletType: e.None
  }) => {
    if (p.isNil(n))
      return null;
    switch (t.walletType ? t.walletType : m()) {
      case e.Metamask:
        return n[i.POLYGON];
      case e.Ronin:
      case e.RoninMobile:
      case e.Okx:
      case e.WalletConnect:
      default:
        return n[i.RONIN];
    }
  }, [m]), P = o((n, t = {
    networkType: a.None,
    walletType: e.None
  }) => {
    if (p.isNil(n))
      throw new Error("Address map is not provided");
    switch (t.networkType) {
      case a.Polygon:
        return n[i.POLYGON];
      case a.Ronin:
        return n[i.RONIN];
    }
    switch (t.walletType ? t.walletType : m()) {
      case e.Metamask:
        return n[i.POLYGON];
      case e.Ronin:
      case e.RoninMobile:
      case e.Okx:
      case e.WalletConnect:
      default:
        return n[i.RONIN];
    }
  }, [m]), W = o((n) => {
    switch (n) {
      case e.WalletConnect:
        return R.WalletConnect;
      case e.Metamask:
        return R.Metamask;
      case e.Okx:
        return R.Okx;
      case e.Ronin:
      case e.RoninMobile:
      default:
        return R.Ronin;
    }
  }, []), x = o((n, t) => {
    switch (n) {
      case a.Polygon:
        return `${d.URL.TRANSACTION.POLYGON}${t}`;
      case a.Ronin:
      default:
        return `${d.URL.TRANSACTION.RONIN}${t}`;
    }
  }, []);
  return {
    detectWalletType: m,
    getChainConfigs: u,
    getChainDomain: O,
    getChainIdByType: y,
    getChainIdByWalletType: k,
    getChainName: g,
    getChainImage: h,
    getChainProvider: I,
    getChainType: A,
    getContractAbi: M,
    getContractAddress: P,
    getWalletProvider: W,
    getTransactionUrl: x
  };
};
export {
  re as default
};
//# sourceMappingURL=useChainSwitcher.js.map
